import React, { Component } from 'react';
import CountyPolygons from './CountyPolygons.json';
import ServiceAreaMap from './ServiceAreaMap';
import Breakpoint from './Breakpoint';
import { getCounties, getStates } from '@capcenter/shared';
import { Colors } from '@capcenter/shared';
import { AddressSearch, Icon } from '@capcenter/shared-legacy';

export class MapContainer extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      polygons: [],
      loading: true,
      counties: [],
      currentCounty: undefined,
    };
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;

    getCounties().then(counties => {
      if (typeof counties !== 'string') {
        getStates().then(states => {
          if (typeof states !== 'string') {
            this.matchPolygons(states, counties);
          } else {
            this.setError(states);
          }
        });
      } else {
        this.setError(counties);
      }
    });
  }

  lookForCenter = (extremes, lat, lng) => {
    let newExtremes = JSON.parse(JSON.stringify(extremes));

    if (lat > extremes.latLarge || extremes.latLarge === 0) {
      newExtremes.latLarge = lat;
    }
    if (lat < extremes.latSmall || extremes.latSmall === 0) {
      newExtremes.latSmall = lat;
    }
    if (lng > extremes.lngLarge || extremes.lngLarge === 0) {
      newExtremes.lngLarge = lng;
    }
    if (lng < extremes.lngSmall || extremes.lngSmall === 0) {
      newExtremes.lngSmall = lng;
    }

    newExtremes.center = {
      lat: newExtremes.latSmall + (newExtremes.latLarge - newExtremes.latSmall) / 2,
      lng: newExtremes.lngSmall + (newExtremes.lngLarge - newExtremes.lngSmall) / 2,
    };
    newExtremes.size = (newExtremes.latLarge - newExtremes.latSmall) * (newExtremes.lngLarge - newExtremes.lngSmall);

    return newExtremes;
  };

  matchPolygons = (states, counties) => {
    // Create Array for collecting polygons
    let polygons = [];
    let allExtremes = {
      latSmall: 0,
      latLarge: 0,
      lngSmall: 0,
      lngLarge: 0,
      center: 0,
      size: 0,
    };

    let theseCounties = counties;

    // Loop through polygon data set
    CountyPolygons.map((county, i) => {
      // Start check for missing county match
      let exists = false;

      // Check each polygon against all counties in CapCenter database
      theseCounties.map((cCounty, ii) => {
        // Check against both name types
        const altNameArray = county.properties.Geographic_Name.split(',');
        const altName = altNameArray[0];

        if (
          // If the county name matches, and the state matches, it exists, continue
          (county.properties.name.toLowerCase() === cCounty.CountyName.toLowerCase() ||
            altName.toLowerCase() === cCounty.CountyName.toLowerCase()) &&
          county.properties['State Abbr'].toLowerCase() === cCounty.State.toLowerCase()
        ) {
          exists = true;

          // Find coordinates if they exist

          // Create Arrays to hold coordinates, multicoordinates, center and rough size.
          let coords = [];
          let multiCoords = [];
          let extremes = {
            latSmall: 0,
            latLarge: 0,
            lngSmall: 0,
            lngLarge: 0,
            center: 0,
            size: 0,
          };

          county.geometry.coordinates &&
            county.geometry.coordinates[0].map((coor, ii) => {
              const thisLat = parseFloat(coor[1]);
              const thisLng = parseFloat(coor[0]);

              extremes = this.lookForCenter(extremes, thisLat, thisLng);
              allExtremes = this.lookForCenter(allExtremes, thisLat, thisLng);

              coords.push({ lat: thisLat, lng: thisLng });

              return null;
            });

          // Find multi-coordinates if coordinates don't exist
          if (!county.geometry.coordinates) {
            county.geometry.geometries.map((geo, ii) => {
              let theseCoords = [];
              let theseExtremes = {
                latSmall: 0,
                latLarge: 0,
                lngSmall: 0,
                lngLarge: 0,
                center: 0,
              };

              geo.coordinates[0].map((coor, i) => {
                const thisLat = parseFloat(coor[1]);
                const thisLng = parseFloat(coor[0]);

                theseExtremes = this.lookForCenter(theseExtremes, thisLat, thisLng);
                allExtremes = this.lookForCenter(allExtremes, thisLat, thisLng);

                theseCoords.push({ lat: parseFloat(coor[1]), lng: parseFloat(coor[0]) });

                return null;
              });

              multiCoords.push({ coords: theseCoords, extremes: theseExtremes });

              return null;
            });
          }

          // Push found data to Coordinate arrays
          if (multiCoords.length !== 0) {
            multiCoords.map((coordsSingle, ii) => {
              const thisCounty = {
                duplicate: cCounty.used ? true : false,
                multi: true,
                county: cCounty.CountyName,
                state: cCounty.State,
                coords: coordsSingle.coords,
                extremes: coordsSingle.extremes,
                cData: cCounty,
                cId: cCounty.CountyName.replace(/\s/g, '') + cCounty.State,
              };

              polygons.push(thisCounty);

              return null;
            });
          } else {
            const thisCounty = {
              duplicate: cCounty.used ? true : false,
              multi: false,
              county: cCounty.CountyName,
              state: cCounty.State,
              coords: coords,
              extremes: extremes,
              cData: cCounty,
              cId: cCounty.CountyName.replace(/\s/g, '') + cCounty.State,
            };

            //console.log(thisCounty)
            polygons.push(thisCounty);
          }

          theseCounties[ii].used = true;
        }

        return null;
      });

      // If there's not a match in the database, log it.
      if (exists === false) {
        console.log('County polygon - no matched found in CC Database', county);
      }

      return null;
    });

    // sort by size
    polygons.sort((a, b) => a.extremes.size - b.extremes.size);

    if (this._isMounted) {
      this.setState({ polygons, mapCenter: allExtremes.center, loading: false });
    }
  };

  setError = error => {
    console.error(error);
  };

  setCounty = county => {
    if (this._isMounted) {
      this.setState({ currentCounty: county.countyId });
    }
  };

  render() {
    return (
      <Breakpoint>
        {bProps => (
          <>
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: bProps.size === 'xSmall' ? 250 : bProps.size === 'xLarge' ? 500 : 500,
                backgroundColor: '#E5E3DF',
              }}
            >
              {this.state.loading ? (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <h2>
                    <Icon icon="spinner" pulse /> &nbsp;Loading Data
                  </h2>
                </div>
              ) : (
                <ServiceAreaMap
                  initialCenter={{
                    lat: 35.8,
                    lng: bProps.size === 'large' ? -79.75 : -79,
                  }}
                  locations={this.props.locations}
                  zoom={bProps.size === 'xSmall' ? 5 : bProps.size === 'xLarge' ? 6 : 6}
                  polygons={this.state.polygons}
                  setGoogle={() => this.setState({ loading: false })} // This allows address search to load after google mounts
                  setId={id => this.setState({ currentCounty: id })}
                  currentCounty={this.state.currentCounty}
                />
              )}
            </div>

            <div
              style={{
                backgroundColor: Colors.gray350,
                height: bProps.size === 'xSmall' || bProps.size === 'small' || bProps.size === 'xLarge' ? 50 : 60,
              }}
            >
              <div className="container" style={{ padding: 5 }}>
                <div className="row d-flex align-items-center justify-content-center">
                  <div className="col-7 col-lg-7 col-xl-6">
                    <AddressSearch
                      google={false}
                      setCounty={this.setCounty}
                      noPadding={true}
                      log={false}
                      placeholder="Enter Your Location"
                    />
                  </div>
                  <div className="col-5 col-lg-5 col-xl-6">
                    <span className="badge" style={{ backgroundColor: Colors.red500, width: 15, height: 15 }}>
                      &nbsp;&nbsp;
                    </span>
                    &nbsp; Realty & Mortgage Services
                    <br className="d-block d-xl-none" />
                    <span className="d-none d-xl-inline">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span className="badge" style={{ backgroundColor: Colors.primary, width: 15, height: 15 }}>
                      &nbsp;&nbsp;
                    </span>
                    &nbsp; Mortgage Services
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Breakpoint>
    );
  }
}

export default MapContainer;
